// extracted by mini-css-extract-plugin
export default {"text":"TopBar_text__g9K0q","button":"TopBar_button__ITnRH","container":"TopBar_container__ZeHZh","bottom":"TopBar_bottom__9OTA4"};